import React from "react";

export const LoadingOverlay: React.FC = () => {
  return (
    <div className="loadingOverlay">
      <div className="loadingSpinner" />
    </div>
  );
};
